export const FEEDBACKTYPE_NEGATIVE = Symbol('Negative Feedback')
export const FEEDBACKTYPE_POSITIVE = Symbol('Positive Feedback')



// WEBPACK FOOTER //
// ./src/constants/feedbackConstants.js